export default [
  {
    name: 'VisaOrderDetail',
    method: 'post',
    desc: '签证订单详情',
    path: '/obt/qz/order/detail',
    params: {
      orderId: '' // 订单id
    }
  },
  {
    name: 'FillSendInfo',
    method: 'post',
    desc: '签证订单详情',
    path: '/obt/qz/order/fillSendInfo',
    params: {
      orderId: '', // 订单id
      expressCompany: '', // (string): 快递公司 ,
      expressCompanyName: '', // (string): 快递公司名称 ,
      expressNumber: '', // (string): 快递单号 ,
      expressRemark: '', // (string, optional): 寄送备注
    }
  },
  {
    name: 'GetProgress',
    method: 'post',
    desc: '获取签证办理进度',
    path: '/obt/qz/order/blztList',
    params: {
      orderId: '' // 订单id
    }
  },
  { 
    name: 'Cancel',
    method: 'post',
    desc: '获取签证办理进度',
    path: '/obt/qz/order/cancel',
    params: {
      orderId: '' // 订单id
    }
  }
]
